// @flow
import React, { Component, Fragment } from 'react';
import { isBrowser } from 'react-device-detect';
import Button from 'components/common/Button';
import MarkdownRender from 'components/common/MarkdownRender/MarkdownRender';
import './UserAbout.scss';

type Props = {
  about: string,
  self: boolean,
  onEditClick: () => void,
};
type State = {};

class UserAbout extends Component<Props> {
  render() {
    const { about, self, onEditClick } = this.props;
    return (
      <div className="UserAbout">
        {about ? (
          <Fragment>
            {self && (
              <div className="edit-btn-wrapper">
                <Button onClick={onEditClick} desktop={isBrowser}>
                  수정하기
                </Button>
              </div>
            )}
            <MarkdownRender body={about} />
          </Fragment>
        ) : (
          <div className="empty-about">
            <div className="text">소개가 등록되지 않았습니다.</div>
            {self && (
              <div className="btn-wrapper">
                <button onClick={onEditClick} desktop={isBrowser}>
                  등록하기
                </button>
              </div>
            )}
          </div>
        )}
      </div>
    );
  }
}

export default UserAbout;



// WEBPACK FOOTER //
// ./src/components/user/UserAbout/UserAbout.js